import React, { useState } from 'react';
import { Button, Modal, Input, Row, Col, Typography, Space } from 'antd';
import { GlobalOutlined, SearchOutlined, CloseOutlined } from '@ant-design/icons';
import ReactCountryFlag from 'react-country-flag';
import { useGoogleTranslate } from '../../providers/GoogleTranslateProvider';

const { Text, Title } = Typography;

const GoogleTranslateButton = () => {
  const { isDialogOpen, closeDialog, openDialog, translateTo, currentLanguage, languages } = useGoogleTranslate();
  const [searchQuery, setSearchQuery] = useState('');

  const filteredLanguages = searchQuery.length < 2
    ? languages
    : languages.filter(
        lang =>
          lang.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          lang.englishName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          lang.code.toLowerCase().includes(searchQuery.toLowerCase())
      );

  const handleSelectLanguage = (langCode) => {
    translateTo(langCode);
  };

  const currentLang = currentLanguage ? languages.find(l => l.code === currentLanguage) : null;
  const displayLang = currentLang || languages.find(l => l.code === 'en');

  return (
    <>
      <Button
        onClick={openDialog}
        icon={
          displayLang ? (
            <ReactCountryFlag
              countryCode={displayLang.countryCode}
              svg
              style={{
                width: '1.2em',
                height: '1.2em',
                verticalAlign: 'middle',
                marginTop: '-2px'
              }}
            />
          ) : (
            <GlobalOutlined />
          )
        }
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#f0f2f5',
          border: '1px solid #d9d9d9',
          borderRadius: '8px',
          height: '40px',
          padding: '0 12px'
        }}
      >
        <span className="lang-text" style={{ marginLeft: '8px', fontWeight: 500 }}>
          {displayLang?.name || 'English'}
        </span>
      </Button>

      <Modal
        open={isDialogOpen}
        onCancel={closeDialog}
        footer={null}
        width={800}
        closeIcon={<CloseOutlined style={{ fontSize: '18px' }} />}
        title={
          <div style={{ padding: '10px 0' }}>
            <Text type="danger" style={{ fontSize: '14px', display: 'block', marginBottom: '4px' }}>
              StrongBody.ai Admin
            </Text>
            <Title level={3} style={{ margin: 0 }}>
              Select Your Language
            </Title>
          </div>
        }
        bodyStyle={{ padding: '20px', maxHeight: '70vh', overflowY: 'auto' }}
        style={{ top: 40 }}
      >
        <Input
          placeholder="Search language..."
          prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          size="large"
          style={{ marginBottom: '24px', borderRadius: '10px' }}
          allowClear
        />

        <Row gutter={[16, 16]}>
          {filteredLanguages.map(lang => (
            <Col xs={12} sm={8} md={6} key={lang.code}>
              <div
                onClick={() => handleSelectLanguage(lang.code)}
                style={{
                  padding: '16px',
                  backgroundColor: currentLanguage === lang.code ? '#fff1f0' : '#fafafa',
                  border: currentLanguage === lang.code ? '1px solid #ff4d4f' : '1px solid #f0f0f0',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.3s'
                }}
                className="lang-item-hover"
              >
                <ReactCountryFlag
                  countryCode={lang.countryCode}
                  svg
                  style={{
                    width: '1.5em',
                    height: '1.5em',
                  }}
                />
                <Text strong style={{ fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {lang.name}
                </Text>
              </div>
            </Col>
          ))}
        </Row>
        
        <div style={{ textAlign: 'center', marginTop: '30px', color: '#bfbfbf', fontSize: '12px' }}>
          Powered by Google Translate
        </div>
        
        <style>
          {`
            .lang-item-hover:hover {
              border-color: #ff4d4f !important;
              background-color: #fff1f0 !important;
              transform: translateY(-2px);
              box-shadow: 0 4px 12px rgba(0,0,0,0.05);
            }
            @media (max-width: 576px) {
              .lang-text {
                display: none !important;
              }
              .ant-btn {
                padding: 0 8px !important;
              }
            }
          `}
        </style>
      </Modal>
    </>
  );
};

export default GoogleTranslateButton;
